<div class="alert" [ngClass]="alertClass()" @newAlertAnimation>
    <div>
        <img src='{{ "assets/images/" + alertIcon(alert) + ".svg" }}'/>
        <div>
            <strong>{{ alert.message.title | uppercase }}</strong>
            <span> {{ alert.message.content }}</span>
        </div>
    </div>

    <button type="button" (click)="removeAlert()">
        <img src="assets/images/close.svg"/>
    </button>
</div>